export default "__VITE_ASSET__3WmuKvNF__"